const EventRoutes = {
  createDragonEvent: "/event/createEventDragon",
  createAdvisionEvent: "/event/createEventAdvision",
  createEvent: "/userEvent/register"
};

export default EventRoutes;